// Cadence block — card click toggle + selling_plan hidden input update.
// Simple Bundles widget styling moved to assets/flavor-block.js since
// flavors now live in a separate block.

(function () {
  function init(root) {
    if (!root || root.dataset.cadenceInit === '1') return;
    root.dataset.cadenceInit = '1';

    var planInput = root.querySelector('[data-cadence-selling-plan]');
    var options = root.querySelectorAll('[data-cadence-option]');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        var plan = opt.getAttribute('data-cadence-plan') || '';
        if (planInput) planInput.value = plan;
        root.dispatchEvent(new CustomEvent('cadence:changed', {
          bubbles: true,
          detail: { plan: plan, option: opt.getAttribute('data-cadence-option') }
        }));
      });
    });
  }

  function bootAll() {
    document.querySelectorAll('[data-cadence-block]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', bootAll);
  document.addEventListener('shopify:block:load', bootAll);
})();
